// extracted by mini-css-extract-plugin
export var link = "storeLinks-module--link--L23PY";
export var store = "storeLinks-module--store--LtJxJ";